import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { RoomMasterInfoForm } from './RoomMasterInfoForm';


const ROOM_TABLE_HEADER = [
    {
        header: 'Room No',
        accessor: (row) => row?.room_no
    },
];

const initialRadiologyRoomMasterDataObj = {
    data: [],
    loading: false
};

export const RadiologyRoomMaster = () => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [roomMasterDataObj, setRoomMasterDataObj] = useState(initialRadiologyRoomMasterDataObj);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [addDetailsDialogueOpen, setAddDetailsDialogOpen] = useState(false)
    const [roomDetailList, setRoomDetailList] = useState([])
    const [subGroupDropdown, setSubGroupDropdown] = useState([])

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                subgroup: Yup.string().required('Sub group is required')
            })
        ),
        defaultValues: { subgroup: '' },
        mode: 'all'
    });
    const { handleSubmit, setValue, reset, watch } = methods;

    useEffect(() => {
        if (selectedRecord) {
            setValue('subgroup', selectedRecord.subgroup);
            setValue('default', selectedRecord.status === 'default');
        } else {
            reset();
        }
    }, [setValue, reset, selectedRecord]);



    const getSubGroupDropDown = useCallback(async () => {
        try {
            const data = await dropdownFetch('subgroup-master');
            setSubGroupDropdown(data);
        } catch (error) {
            console.error('Error fetching Service Dropdown:', error);
            setSubGroupDropdown([]);
        }
    }, []);

    useEffect(() => {
        getSubGroupDropDown();
    }, [getSubGroupDropDown])

    const formSubmit = async (formValues) => {
        setLoading(true);
        const response = await request('/radiology-room-master-create', {
            method: 'POST',
            body: { ...formValues, rooms: roomDetailList }
        });
        if (response?.success) {
            toast(`Successfully ${'created'} Room master`, { variant: 'success' });
            setCurrentAction();
            setRoomDetailList([])
            reset()
        } else {
            toast(`Failed to ${'create'} Room master`, { variant: 'error' });
        }
        setLoading(false);
    };
    const handleRoomRowDelete = (rowId) => {
        setRoomDetailList((prev) => prev.filter((data) => data.room_no !== rowId));
    }

    const subgroupwatch = watch('subgroup')

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',

                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Radiology Room Master
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"

                                >
                                    Apply
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
                            <Stack spacing={2}>

                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700 }}>Sub Group</Typography>
                                    <SelectTag
                                        name="subgroup"
                                        formControlSX={{
                                            flex: 0.8,
                                            border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : ""
                                        }}
                                        placeholder="Select Sub Group"
                                        fullWidth
                                        menus={subGroupDropdown.map((data) => ({
                                            ...data, name: data.
                                                subgroupname
                                        }))}
                                    />
                                </Stack>

                            </Stack>
                            <Grid item xs={12} sx={{ marginTop: "2%" }}>
                                <Stack spacing={1} direction="row" justifyContent="flex-end">
                                    <Button
                                        variant="outlined"
                                        onClick={() => setAddDetailsDialogOpen(true)}
                                        disabled={!subgroupwatch}
                                        sx={{ color: "blue", cursor: "pointer" }}
                                    >
                                        Add Details
                                    </Button>
                                </Stack>
                                <Table
                                    data={roomDetailList.map((data) => ({ _id: data.room_no, ...data }))}
                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                    columns={ROOM_TABLE_HEADER}
                                    size="small"
                                    showDeleteAction={true}
                                    onDeleteHandler={handleRoomRowDelete}
                                />
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper>
            <Dialog
                open={addDetailsDialogueOpen}
                onClose={() => setAddDetailsDialogOpen(false)}
                PaperProps={{ sx: { width: '30%', height: '30vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <RoomMasterInfoForm
                    onClose={() => setAddDetailsDialogOpen(false)}
                    setAddDetailsDialogue={setAddDetailsDialogOpen}
                    onAdd={(row) => {
                        if (roomDetailList.some((bed) => bed.room_no === row.room_no)) {
                            toast('Room number already taken', { variant: 'error' });
                        } else {
                            setRoomDetailList((prev) => [...prev, row]);
                        }
                    }}
                />
            </Dialog>
        </>
    );
};
